"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditFile;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _ActionTypes2 = require("FileManagerLib/actions/ActionTypes");

var _Constants = require("FileManagerCore/Constants");

var defaultState = _immutable.default.Map({
  file: null,
  fetchRequestStatus: _Constants.RequestStatus.UNINITIALIZED,
  updateRequestStatus: _Constants.RequestStatus.UNINITIALIZED
});

function EditFile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      file = action.file;

  switch (type) {
    case _ActionTypes2.FETCH_FILE_FOR_EDITING_ATTEMPTED:
      return state.set('fetchRequestStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes2.FETCH_FILE_FOR_EDITING_SUCCEEDED:
      return state.merge({
        file: file,
        fetchRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes2.FETCH_FILE_FOR_EDITING_FAILED:
      return state.set('fetchRequestStatus', _Constants.RequestStatus.FAILED);

    case _ActionTypes2.SAVE_FILE_EDIT_ATTEMPTED:
      return state.set('updateRequestStatus', _Constants.RequestStatus.PENDING);

    case _ActionTypes2.SAVE_FILE_EDIT_SUCCEEDED:
      return state.merge({
        file: file,
        updateRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes2.SAVE_FILE_EDIT_FAILED:
      return state.set('updateRequestStatus', _Constants.RequestStatus.FAILED);

    case _ActionTypes.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED:
    case _ActionTypes.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED:
      return state.set('file', file);

    case _ActionTypes2.CLEAR_FILE_FOR_EDITING:
      return defaultState;

    default:
      return state;
  }
}

module.exports = exports.default;